import {
  ShortNovelasClipsUiModuleBody,
  ShortNovelasClipsUiModuleBodyModuleTypeEnum,
  DocumentLocale,
  EntitlementType
} from '../../../API';
import generateId from '../../../utils/generateId';
import { NewModuleFunction } from '../../../utils/layouts';

export const blankShortNovelasClipsModule: NewModuleFunction<ShortNovelasClipsUiModuleBody> = (module) => ({
  moduleType: ShortNovelasClipsUiModuleBodyModuleTypeEnum.SHORT_NOVELAS_CLIPS,
  moduleId: generateId(),
  title: {
    [DocumentLocale.ES]: ''
  },
  copy: '',
  ctaText: '',
  backgroundFillVideo: '',
  entitlements: [EntitlementType.ANON, EntitlementType.FREE, EntitlementType.SUB],
  ...module
});
